module.exports = __webpack_public_path__ + "img/5ne.dc86efbf.svg";